import BluebirdPromise from 'bluebird';

BluebirdPromise.config({
  cancellation: true,
});



// WEBPACK FOOTER //
// ./src/common/config/bluebirdConfig.js